'use strict';

var _ = require('lodash');
var d3 = require('d3');
var ChartDashboardRankings = function ChartDashboardRankings(AbstractChart, chartGroups, chartTiles, chartSimpleBars, chartXAxis, chartYAxisLines, chartConstants, chartDashboardRankingsDataService, chartBrush, chartCircles) {
  var chartParams = require('./Params');
  var Chart = function Chart(container, formatters, chartScales, yAxis, invertXAxis) {
    var self = this;
    AbstractChart.call(this, container);
    var dispatch = d3.dispatch('rangechange', 'rangechangeend');
    d3.rebind(this, dispatch, 'on');
    var groups = chartGroups('label', formatters.tooltipFormatter, true);
    var m1Bars = chartSimpleBars('m1');
    var m2Bars = chartSimpleBars('m2');
    var tiles = chartTiles('departureDateMoment', 'm2', 'tiles').withHeight(2);
    var lines = chartYAxisLines();
    var brush = chartBrush();
    var circles = chartCircles('circles');
    var xAxisTickValuesHandler = function xAxisTickValuesHandler(data) {
      return _.map(data, 'label');
    };
    var xAxis = chartXAxis(formatters.xAxisTickFormatter, xAxisTickValuesHandler).withTextRotation(chartConstants.AXIS.SKEW.DEG_40_B).invertAxisLine(invertXAxis).withoutLine();
    this.render = function (data, brushRanges) {
      this.initChart(data, [0, data.length], chartParams);
      this.scales = chartScales(this.params, this.data, chartDashboardRankingsDataService.getBarSpaceWidth());
      this.callForPreDataGroup([brush.withDomainRange(this.visibleXRange)], this.scales);
      this.callForDataGroup([lines, groups, m2Bars, m1Bars, tiles, circles, xAxis], this.scales);
      this.callForYAxis(yAxis, this.scales);
      brush.setInitialSelection(brushRanges, true);
    };
    this.setInitialSelection = function (range, silent) {
      brush.setInitialSelection(range, silent);
    };
    this.clearBrush = function () {
      brush.setSelection([0, 0], true);
      dispatch.rangechangeend(brush.getSelection(), true);
    };
    brush.on('brushchange', function (range) {
      self.brushChangeAction(range, groups);
    });
    brush.on('brushend', function (range, silent) {
      dispatch.rangechangeend(range, silent);
    });
    groups.on('groupclick', function (d, i, targetData, event) {
      event.stopPropagation();
      brush.setSelection([i, i + 1]);
      dispatch.rangechangeend(brush.getSelection());
    });
    container.on('$destroy', function () {
      groups.on('groupclick', null);
      brush.on('brushchange', null);
      brush.on('brushend', null);
    });
  };
  Chart.prototype = Object.create(AbstractChart.prototype);
  Chart.constructor = Chart;
  return Chart;
};
ChartDashboardRankings.$inject = ['AbstractChart', 'ChartElementsGroup', 'ChartElementsTiles', 'ChartElementsSimpleBars', 'ChartElementsXAxis', 'ChartElementsYAxisLines', 'ChartElementsConstants', 'ChartDashboardRankingsDataService', 'ChartElementsMultiBrush', 'ChartElementsCircles'];
module.exports = ChartDashboardRankings;